"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * return object looked like, eg:
 * { link: PropTypes.string, link_active: PropTypes.string }
 * @param {string[]} themeApi
 * @returns {{}}
 */
var _default = exports["default"] = function _default(themeApi) {
  if (!Array.isArray(themeApi)) {
    throw new Error('themeApi should be array of strings');
  }
  var themeShape = {};
  themeApi.forEach(function (className) {
    themeShape[className] = _propTypes["default"].string.isRequired;
  });
  return _propTypes["default"].shape(themeShape);
};